import Dropdown from "common/Dropdown/Dropdown.tsx";
import React, { useContext, useState } from "react";
import { ItemType } from "antd/es/menu/interface";
import { ActionsDropdownIcon } from "common/styles.ts";
import SwapOutlined from "@ant-design/icons/SwapOutlined";
import SellCoinAction from "features/portfolio/Assets/SellCoinAction.tsx";
import { ConsolidatedCoinDataWithKey, LanguageNameSpaces } from "@shared/types";
import Text from "common/Typography/Text.tsx";
import Flex from "common/Boxes/Flex.tsx";
import EditOutlined from "@ant-design/icons/EditOutlined";
import { PositionsContext } from "features/portfolio/Positions/Positions.context.ts";
import styled, { useTheme } from "styled-components";
import NewLookKebab from "features/portfolio/NewLook/NewLookKebab.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface CoinActionsDropdownProps {
  coinData: ConsolidatedCoinDataWithKey;
  isPosition?: boolean;
  showEditLeverage?: boolean;
}

const CoinActionsDropdown = ({
  coinData,
  isPosition,
  showEditLeverage,
}: CoinActionsDropdownProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { setChangeLeverageCoinData } = useContext(PositionsContext) || {};
  const { isNewLook } = useTheme();

  const menuItems: ItemType[] = [
    {
      key: "sellCoin",
      onClick: () => {},
      label: (
        <SellCoinAction
          coinData={coinData}
          isPosition={isPosition}
          trigger={
            <Text>
              <SwapOutlined style={{ marginRight: 8 }} />
              {isPosition
                ? t("buttons.close_position")
                : t("buttons.sell_coin")}
            </Text>
          }
        />
      ),
    },
  ];

  if (isPosition && showEditLeverage) {
    menuItems.push({
      key: "updateLeverage",
      onClick: () => setChangeLeverageCoinData?.(coinData),
      label: t("buttons.update_leverage"),
      icon: <EditOutlined />,
    });
  }

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Dropdown
        title={t("actions.coin_actions")}
        menu={{ items: menuItems }}
        trigger={["click"]}
        onOpenChange={setDropdownOpen}
        open={dropdownOpen}
      >
        {isNewLook ? (
          <NewLookKebab aria-label={t("actions.coin_actions")} />
        ) : (
          <IconWrapper>
            <ActionsDropdownIcon />
          </IconWrapper>
        )}
      </Dropdown>
    </div>
  );
};

export default CoinActionsDropdown;

const IconWrapper = styled(Flex)`
  right: -8px;
  margin-left: -8px;
  position: relative;
`;
